import axios from "axios";
import { SERVER_URL } from "./serverUrl.js";
import { getToken } from "../helper/storage.js";

axios.defaults.baseURL = SERVER_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.maxContentLength = 100000000;

axios.interceptors.request.use(async (config) => {
  const token = await getToken("USER_KEY");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});
export default axios;
